import { V } from '../common/Layout';
import { FormContext } from '../common/form/FormContext';
import React, { useContext, useEffect } from 'react';
import { fieldEditors, Type } from './attributes';

import { Typography } from '@mui/material';

type FieldEditorProps = {
    type: Type;
    termsetsData: any;
    validationCallback: (isValid: boolean) => void;
};

export default (props: FieldEditorProps) => {
    const { type, termsetsData, validationCallback } = props;
    const Editor = fieldEditors[type.fieldType];
    const { validation } = useContext(FormContext);

    useEffect(() => {
        if (validation) {
            const handleCallback = () => {
                validationCallback(validation?.isValid);
            };
            handleCallback();
        }
    }, [validationCallback, validation]);

    return (
        <V>
            <Typography sx={{ p: 2 }}>{type.description}</Typography>
            <Editor termsetsData={termsetsData} />
        </V>
    );
};
